import { profileDetailsSlice } from "./profile";
import { apiErrorSlice } from "./apiErrorHandler";
import { businessDetailsSlice } from "./businessInfo";

export const rootReducer = {
  profileDetailsReducer: profileDetailsSlice.reducer,
  apiErrorReducer: apiErrorSlice.reducer,
  businessDetailsreducer: businessDetailsSlice.reducer,
};
